export interface LauteAudioCommand { id: string; itemId: string; audioId: string }

/** Snapshot restoration establishes a baseline; only a later, new command may play. */
export function createLauteAudioDelivery() {
  let runId = "";
  let commandId: string | null = null;
  return (input: { runId: string; command: LauteAudioCommand | null; connected: boolean; synchronized: boolean; enabled: boolean; paused: boolean; itemId?: string; audioId?: string; running: boolean }) => {
    if (!input.connected || !input.synchronized || runId !== input.runId) {
      runId = input.runId; commandId = input.command?.id ?? null; return null;
    }
    if (!input.command || input.command.id === commandId) return null;
    commandId = input.command.id;
    return input.enabled && !input.paused && input.running && input.command.itemId === input.itemId && input.command.audioId === input.audioId ? input.audioId ?? null : null;
  };
}
